import * as Yup from 'yup';
import { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useFormik } from 'formik';
import { store } from 'react-notifications-component';
import { useTranslation } from 'react-i18next'
import branchApi from "../../../store/branchStore/branchApi";
import branchActions from "../../../store/branchStore/branchActions";
import {useHistory} from "react-router-dom";

export const useBonusTagForm = () => {
    const dispatch = useDispatch();
    const history = useHistory();
    const { t } = useTranslation();
    const [errorModal, setErrorModal] = useState(false);
    const [error, setError] = useState(false);
    const [deletingTag, setDeletingTag] = useState(false);
    const [deleteTagId, setDeleteTagId] = useState(false);
    const [tagId, setTagId] = useState(false);
    const { info, pending } = useSelector(s => s.branchReducer);
    const [phone, setPhone] = useState("")

    const formik = useFormik({
        initialValues: {
            bonusPercentage: '',
            title: '',
            backgroundColor: '#F2F2F2',
            color: '#1E1E1E',
            phoneNumbers: [],
            file: null,
            isDiscount: false,
        },
        validationSchema: Yup.object({
        }),
        onSubmit: (async (values, { setSubmitting }) => {
            try {
                setSubmitting(true)
                if (info.id) {
                    const formData = new FormData()
                    formData.append('bonus_percentage', values.bonusPercentage)
                    formData.append('title', values.title)
                    formData.append('background_color', values.backgroundColor)
                    formData.append('color', values.color)
                    formData.append('file', values.file)
                    formData.append('phone_numbers', values.phoneNumbers.join(','))
                    formData.append('is_discount', values.isDiscount)

                    await branchApi.postBranchTagConfiguration(info.id, formData)
                    dispatch(branchActions.getBranch(info.id));
                    formik.resetForm()
                    setPhone('')
                }
            } catch (e) {
                const res = e.response ? e.response.data : null;

                store.addNotification({
                    title: `Error code: ${res ? res.code : 'NULL'}`,
                    message: `${res ? res.message : t('Notify.notRespond')}`,
                    type: "danger",
                    insert: "top",
                    container: "top-right",
                    animationIn: ["animate__animated", "animate__fadeIn"],
                    animationOut: ["animate__animated", "animate__fadeOut"],
                    dismiss: {
                        duration: 5000,
                        onScreen: true
                    }
                });
            } finally {
                setSubmitting(false)
            }
        })
    });

    useEffect(() => {
        formik.setErrors({});
        formik.setTouched({});
        if (info) {
            // if (!info.configuration.tags || !info.configuration.tags) {
            //     setError(true);
            //     setErrorModal(true);
            // }
        }
    }, [info]);

    const handleAddPhone = () => {
        if (phone.length === 11) {
            if (formik.values.phoneNumbers.some(p => p === phone)) {
                return
            }
            formik.setFieldValue('phoneNumbers', [...formik.values.phoneNumbers, phone]);
            setPhone('')
        } else {
            store.addNotification({
                title: '',
                message: t('Form.correctPhone'),
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animate__animated", "animate__fadeIn"],
                animationOut: ["animate__animated", "animate__fadeOut"],
                dismiss: {
                    duration: 5000,
                    onScreen: true
                }
            });
        }
    }

    const handleDeleteTag = async (tagId) => {
        try {
            if (info.id) {
                setDeletingTag(true)
                await branchApi.deleteBranchTag(info.id, tagId)
                dispatch(branchActions.getBranch(info.id));
                formik.resetForm()
            }
        } catch (e) {
            const res = e.response ? e.response.data : null;

            store.addNotification({
                title: `Error code: ${res ? res.code : 'NULL'}`,
                message: `${res ? res.message : t('Notify.notRespond')}`,
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animate__animated", "animate__fadeIn"],
                animationOut: ["animate__animated", "animate__fadeOut"],
                dismiss: {
                    duration: 5000,
                    onScreen: true
                }
            });
        } finally {
            setDeletingTag(false)
            setDeleteTagId('')
        }
    }

    const handleLoadFiles = (file) => {
        formik.setFieldValue('file', file);
    }

    return {
        formik,
        phone,
        handleAddPhone,
        handleDeleteTag,
        setDeleteTagId,
        deleteTagId,
        history,
        setTagId,
        tagId,
        setPhone,
        pending,
        errorModal,
        setErrorModal,
        error,
        deletingTag,
        handleLoadFiles,
        t,
        info,
    }
}
